/**
 * Created by Carry on June/11/18.
 */
export default {
    // 可播放视频组件的id
    MAIN_VIEW: 'MAIN_VIEW', // 单个预览视频view

    // 位置（九宫格）
    LEFT_TOP: 'left-top',
    TOP: 'center-top',
    RIGHT_TOP: 'right-top',
    RIGHT: 'right-center',
    RIGHT_BOTTOM: 'right-bottom',
    BOTTOM: 'center-bottom',
    LEFT_BOTTOM: 'left-bottom',
    LEFT: 'left-center',
    CENTER: 'center',

    POSITION_LEFT: 'POSITION_LEFT',
    POSITION_CENTER_VERTICAL: 'POSITION_CENTER_VERTICAL',
    POSITION_RIGHT: 'POSITION_RIGHT',
    POSITION_TOP: 'POSITION_TOP',
    POSITION_CENTER_HORIZONTAL: 'POSITION_CENTER_HORIZONTAL',
    POSITION_BOTTOM: 'POSITION_BOTTOM',

    // ratio
    RATIO_VERTICAL: 'RATIO_VERTICAL', // 9:16

    // graph type
    GRAPH_GROUP: 'GRAPH_GROUP',
    GRAPH_SUBTITLE_TEXT: 'subtitleText',
    GRAPH_TEXT_MASK: 'GRAPH_TEXT_MASK',
    GRAPH_WEBGL_EFFECT: 'GRAPH_GL_EFFECT',

    PIP_ELEMENT_VIDEO: 'PIP_VIDEO',

    ANCHOR_TOP: 'ANCHOR_TOP',
    ANCHOR_CENTER: 'ANCHOR_CENTER',
    ANCHOR_BOTTOM: 'ANCHOR_BOTTOM',
    HIGHLIGHT_COLOR: 'HIGHLIGHT_COLOR',
    SHAPE_COLOR: 'SHAPE_COLOR',
    ANIMATION_NAME: 'ANIMATION_NAME',
};
